var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoneySend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 13.75C9.75 14.72 10.5 15.5 11.42 15.5H13.3C14.1 15.5 14.75 14.82 14.75 13.97C14.75 13.06 14.35 12.73 13.76 12.52L10.75 11.47C10.16 11.26 9.76001 10.94 9.76001 10.02C9.76001 9.17999 10.41 8.48999 11.21 8.48999H13.09C14.01 8.48999 14.76 9.26999 14.76 10.24",
    stroke: "#00AA5B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 7.5V16.5",
    stroke: "#00AA5B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 12C22.25 17.52 17.77 22 12.25 22C6.73 22 2.25 17.52 2.25 12C2.25 6.48 6.73 2 12.25 2",
    stroke: "#00AA5B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 6V2H18.25",
    stroke: "#00AA5B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 7L22.25 2",
    stroke: "#00AA5B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneySend);
export default __webpack_public_path__ + "static/media/moneySend.331a77a5e82f15e0bc388606aaf42804.svg";
export { ForwardRef as ReactComponent };